/**
 * One service of the booking, in the order the group runs it. The server resolves each for the expert and
 * answers with the starts the whole booking fits, gaps in split services excluded.
 */
export interface BookedService {
  choiceId: number;
  addonServiceItemIds?: number[];
}

export interface ExpertsScheduleMap {
  [expertId: number]: {
    expertId: number;
    timeSlots: ExpertScheduleTimeSlot[];
  };
}

export enum TimeSlotInactiveReason {
  SkipFromDisplay = 'hide_ui', // e.g. skip time slots at 15 minutes, keep only those at 30 min
  SlotInThePast = 'past_slot', // e.g. skip time slots at 15 minutes, keep only those at 30 min
  ExpertTimeoff = 'timeoff', // expert time off or existing appointment
  ExistingAppointment = 'appointment', // expert time off or existing appointment
  CrossGroupOverlap = 'cross_group_overlap', // overlap with another group within the same appointment
  OutsideWorkingHours = 'outside_working_hours', // the booking runs past the end of the expert's working hours
}

export interface ExpertScheduleTimeSlot {
  startTime: string;
  isActive: boolean;
  inactiveReason?: TimeSlotInactiveReason;
  reason?: TimeSlotInactiveReason;
}

export interface NextAvailableDateResult {
  nextAvailableDate: string | null;
  searchedUntil: string;
}
